export default __webpack_public_path__ + "static/media/pieczatka11.3e99ad0f.gif";